/* Base translations · Analytics, digital audit, vouching / aging extras, inventory — moved unchanged out of lib/i18n.js (STEP 2 · B2).
   Top-level keys owned by this file (no other base file and not i18n.js define them): analyticsExtras, digitalAudit, vouchingExtras, agingExtras, agingActions, samplingSelector, inv6. */
export const I18N_BASE_ANALYTICS = {
  en: {
    analyticsExtras: {
      recomputeRunning: "Analytics recompute already running — polling…",
      recomputeQueued: "Analytics recompute queued.",
      recomputeFailed: "Failed to enqueue analytics recompute.",
      obsGenerated: "Observations generated",
      obsStatistical: "No AI answer was produced — statistical observations are shown instead",
      obsFailed: "Failed",
      scanning: "Scanning…",
      polling: "Polling…",
      runAnalytics: "Run Analytics",
      cachedStale: "Cached (stale — GL changed)",
      cached: "Cached",
      recomputing: "Recomputing…",
      recompute: "Recompute",
      recomputeRunningEmpty: "Analytics recompute is running on the worker fleet — this page will refresh automatically.",
      noAnalyticsCached: "No analytics cached yet. Click Run Analytics to compute revenue, expense and balance-sheet analytics for this engagement.",
      testTheseNow: "Test these now",
      testTheseNowTitle: "Open Sampling with Continuous testing pre-selected for this rule",
      customer: "Customer",
      vendor: "Vendor",
      dates: "Dates",
      account: "Account",
      balance: "Balance",
      lastDate: "Last date",
      reason: "Reason",
      concentrationHigh: "> 25%",
      expectedPct: "Expected %",
      actualPct: "Actual %",
      receivablesSuffix: "— Receivables",
      payablesSuffix: "— Payables",
      thresholdTitle: "Threshold breach (ad-hoc)",
      thresholdDesc: "Flag every transaction whose absolute amount is at or above a threshold you set on the Sampling tab.",
    },
    digitalAudit: {
      pickFile: "Pick a CSV / XLSX / XLS file.",
      requiredCols: "Required columns",
      optionalCols: "Optional columns",
      upload: "Upload",
      uploading: "Uploading…",
      subLedger: {
        title: "Upload Sub-Ledger Detail",
        desc: "Invoice-level detail (not head-wise). Zero impact on the Sampling / Vouching head-upload",
      },
      inventory: {
        title: "Upload Inventory Movements",
        desc: "SKU-level movement detail (receipts, issues, adjustments). Zero impact on any GL / aging",
        grn: "GRN",
        txnAccepts: "Transaction Type accepts",
        txnAliases: "(aliases like",
        txnAlsoAccepted: "also accepted).",
        txnQtyNote: "Qty may be signed on adjustment rows; on receipt/issue the sign is implied by the type.",
      },
      tradePayable: {
        title: "Upload Trade Payable Detail",
        desc: "Bill-level A/P detail (not head-wise). Zero impact on the Sampling / Vouching head-upload",
        aliases: "(aliases like",
        txnAccepts: "Transaction Type accepts",
        txnAliases: "(aliases like",
        txnAlsoAccepted: "also accepted).",
      },
      drilldown: {
        empty: "No entries in this bucket.",
        postedBy: "Posted by",
      },
    },
    vouchingExtras: {
      txAssertions: "Transaction-Level Assertions",
      balAssertions: "Balance-Level Assertions",
      noRows: "No rows.",
      supportRef: "Support ref",
      docs: "Docs",
      selectionReason: "Reason for selection",
      attachDoc: "Attach the supporting document to this row",
      copy: "Copy",
      overall: "Overall",
      missDocBypass: "Miss-doc bypass",
      remarks: "Remarks",
      review: "Review",
      copyPrevAssertions: "Copy applicable assertions from the previous row",
      copyAllAssertions: "Copy all assertions from the previous row",
      reviewOnEntry: "Review points on this entry",
    },
    agingExtras: {
      downloadAs: "Download",
      downloadCsv: "Download as CSV",
      downloadXls: "Download as XLS",
      downloadXlsx: "Download as XLSX",
      invoices: "Invoices",
      amount: "Amount",
      pctOfTotal: "% of total",
      totalOutstanding: "Total outstanding",
      rowsImported: "Rows imported",
      overdue90: "Overdue > 90 days",
      bucketBreakdown: "Bucket breakdown",
      topParties: "Top parties",
      total: "Total",
      current: "Current",
    },
    agingActions: {
      uploaded: "{kind} aging uploaded",
      exported: "{kind} aging exported ({fmt})",
      uploadFailed: "Upload failed",
      exportFailed: "Export failed",
      agingUploadFailed: "Aging upload failed",
    },
    samplingSelector: {
      fileInFolder: "File in folder",
      fileInFolderPh: "Pick a folder: FS head, Journal Entry testing or Tests of Controls",
      fileInFolderHint: "Sample will appear as -03 (Sample link) in the folder you pick.",
      entriesSuffix: "entries",
      noFoldersHint: "No FS heads found — run the FS Mapping first.",
      pickFolderRequired: "Pick a folder in \"File in folder\" before running the sample.",
      folderRef: "Folder",
    },
    // Batch C · Round C2 · W6 — Inventory count worksheet (folder 1201) — EN
    inv6: {
      parsed: "Parsed", viewRows: "View rows", noFile: "No file uploaded yet — upload the count sheet",
      title: "Inventory count worksheet",
      section: {
        count_details: "Count details",
        mgmt_instructions: "Management's count instructions evaluated",
        observation: "Observation notes",
        condition: "Condition (damaged / obsolete / slow-moving)",
        test_counts: "Test counts",
        final_records: "Final inventory records",
        third_party: "Inventory held by third parties",
        attendance: "Attendance",
      },
      countDate: "Count date",
      locations: "Locations",
      countedBy: "Counted by",
      countAtFsDate: "Count at FS date?",
      movements: "Movements between count date and FS date",
      damaged: "Damaged", obsolete: "Obsolete", slowMoving: "Slow-moving",
      sheetToFloor: "Sheet-to-floor (from Sampling)",
      floorToSheet: "Floor-to-sheet (entered here)",
      testColItem: "Item",
      testColLocation: "Location",
      listingQty: "Listing qty", countedQty: "Counted qty", diff: "Difference",
      unitCost: "Unit cost", valueDiff: "Value difference",
      finalListing: "Final listing", countResults: "Count results", tbTotal: "TB total",
      diffExplain: "Difference explanation",
      thirdPartyHeld: "Held by third party?",
      thirdPartyName: "Third party name",
      confirmationLink: "Confirmation link",
      otherProcedures: "Other procedures note",
      attendanceMode: {
        attended: "Attended",
        unable_unforeseen: "Unable to attend — unforeseen",
        impracticable: "Impracticable",
      },
      attendanceReason: "Reason",
      altProcedures: "Alternative procedures note",
      uploadListing: "Upload client count listing \u2068(.xlsx / .csv)\u2069",
      uploadListingFirst: "Upload the client count listing first.",
      uploadOk: "Listing uploaded.",
      totalValue: "Total value",
      sendToSampling: "Send to Sampling — Physical count",
      sendToSamplingOk: "Sent to Sampling.",
      samplingSourceName: "Physical count — client count listing (1201)",
      addFloorRow: "Add floor-to-sheet row",
      linkTo314a: "Open 314(a) — Inventory Count Observation",
      mgmt: {
        coverage: "Complete coverage",
        cut_off: "Cut-off",
        identification: "Identification",
        recording: "Recording",
        custody: "Custody",
        damaged_notes: "Damaged / obsolete flagging",
        note: "Notes",
        evaluatedFlag: "Instructions evaluated (overall)",
      },
      conclusion: "Conclusion", preparer: "Preparer", reviewer: "Reviewer",
      markComplete: "Mark complete",
      reasons: {
        attendance_not_set: "Set the attendance mode.",
        alternative_procedures_required: "Alternative procedures note is required when attendance is not achieved.",
        management_instructions_not_evaluated: "Evaluate management's count instructions.",
        unexplained_final_difference: "Explain the final-records difference.",
        conclusion_missing: "Conclusion is required.",
        preparer_missing: "Preparer sign-off is required.",
        reviewer_missing: "Reviewer sign-off is required.",
      },
    },
  },
  ar: {
    analyticsExtras: {
      recomputeRunning: "إعادة حساب التحليلات قيد التشغيل بالفعل — جاري الاستطلاع…",
      recomputeQueued: "تم إدراج إعادة حساب التحليلات في قائمة الانتظار.",
      recomputeFailed: "فشل إدراج إعادة حساب التحليلات.",
      obsGenerated: "تم إنشاء الملاحظات",
      obsStatistical: "لم يُنتج الذكاء الاصطناعي إجابة — تُعرض ملاحظات إحصائية بدلًا منها",
      obsFailed: "فشل",
      scanning: "جاري المسح…",
      polling: "جاري الاستطلاع…",
      runAnalytics: "تشغيل التحليلات",
      cachedStale: "مخزّن (قديم — تغيّر الأستاذ)",
      cached: "مخزّن",
      recomputing: "جاري إعادة الحساب…",
      recompute: "إعادة حساب",
      recomputeRunningEmpty: "إعادة حساب التحليلات قيد التشغيل على أسطول العمّال — سيتم تحديث هذه الصفحة تلقائياً.",
      noAnalyticsCached: "لا توجد تحليلات مخزّنة بعد. اضغط \"تشغيل التحليلات\" لحساب تحليلات الإيرادات والمصروفات والميزانية لهذه المهمة.",
      testTheseNow: "اختبر هذه الآن",
      testTheseNowTitle: "افتح العينات مع اختيار الاختبار المستمر مسبقاً لهذه القاعدة",
      customer: "العميل",
      vendor: "المورد",
      dates: "التواريخ",
      account: "الحساب",
      balance: "الرصيد",
      lastDate: "آخر تاريخ",
      reason: "السبب",
      concentrationHigh: "> 25%",
      expectedPct: "% المتوقع",
      actualPct: "% الفعلي",
      receivablesSuffix: "— الذمم المدينة",
      payablesSuffix: "— الذمم الدائنة",
      thresholdTitle: "تجاوز الحد (مخصص)",
      thresholdDesc: "ميّز كل معاملة يبلغ مبلغها المطلق حداً معيّناً أو يتجاوزه، يتم ضبطه في تبويب العينات.",
    },
    digitalAudit: {
      pickFile: "اختر ملف CSV / XLSX / XLS.",
      requiredCols: "الأعمدة المطلوبة",
      optionalCols: "الأعمدة الاختيارية",
      upload: "رفع",
      uploading: "جاري الرفع…",
      subLedger: {
        title: "رفع تفاصيل دفتر الأستاذ الفرعي",
        desc: "تفاصيل على مستوى الفاتورة (ليس على مستوى البند). لا يوجد تأثير على رفع البنود للعينات / التوثيق",
      },
      inventory: {
        title: "رفع حركات المخزون",
        desc: "تفاصيل على مستوى SKU (استلامات، صرف، تسويات). لا يوجد تأثير على الأستاذ / الأعمار",
        grn: "إشعار الاستلام",
        txnAccepts: "نوع المعاملة يقبل",
        txnAliases: "(أسماء بديلة مثل",
        txnAlsoAccepted: "مقبولة أيضاً).",
        txnQtyNote: "قد تكون الكمية موجبة أو سالبة على صفوف التسوية؛ في الاستلام/الصرف تُستنتج الإشارة من النوع.",
      },
      tradePayable: {
        title: "رفع تفاصيل الذمم الدائنة",
        desc: "تفاصيل على مستوى الفاتورة للذمم الدائنة (ليس على مستوى البند). لا يوجد تأثير على رفع البنود للعينات / التوثيق",
        aliases: "(أسماء بديلة مثل",
        txnAccepts: "نوع المعاملة يقبل",
        txnAliases: "(أسماء بديلة مثل",
        txnAlsoAccepted: "مقبولة أيضاً).",
      },
      drilldown: {
        empty: "لا توجد قيود في هذه الفئة.",
        postedBy: "المسجِّل",
      },
    },
    vouchingExtras: {
      txAssertions: "تأكيدات على مستوى المعاملة",
      balAssertions: "تأكيدات على مستوى الرصيد",
      noRows: "لا توجد صفوف.",
      supportRef: "مرجع الدعم",
      docs: "المستندات",
      selectionReason: "سبب الاختيار",
      attachDoc: "إرفاق المستند المؤيد لهذا الصف",
      copy: "نسخ",
      overall: "الإجمالي",
      missDocBypass: "تجاوز نقص المستندات",
      remarks: "الملاحظات",
      review: "المراجعة",
      copyPrevAssertions: "نسخ التأكيدات المطبقة من الصف السابق",
      copyAllAssertions: "نسخ كل التأكيدات من الصف السابق",
      reviewOnEntry: "نقاط المراجعة على هذا القيد",
    },
    agingExtras: {
      downloadAs: "تنزيل",
      downloadCsv: "تنزيل CSV",
      downloadXls: "تنزيل XLS",
      downloadXlsx: "تنزيل XLSX",
      invoices: "الفواتير",
      amount: "المبلغ",
      pctOfTotal: "% من الإجمالي",
      totalOutstanding: "إجمالي المستحق",
      rowsImported: "الصفوف المستوردة",
      overdue90: "متأخر > 90 يوماً",
      bucketBreakdown: "تفصيل الفئات العمرية",
      topParties: "أعلى الأطراف",
      total: "الإجمالي",
      current: "حالي",
    },
    agingActions: {
      uploaded: "تم رفع أعمار {kind}",
      exported: "تم تصدير أعمار {kind} ({fmt})",
      uploadFailed: "فشل الرفع",
      exportFailed: "فشل التصدير",
      agingUploadFailed: "فشل رفع الأعمار",
    },
    samplingSelector: {
      fileInFolder: "الحفظ في مجلد",
      fileInFolderPh: "اختر مجلدًا: بند من القوائم المالية أو اختبار قيود اليومية أو اختبارات الرقابة",
      fileInFolderHint: "ستظهر العينة كملف \u2066‎-03‎\u2069 (رابط العينة) في المجلد الذي تختاره.",
      entriesSuffix: "قيود",
      noFoldersHint: "لا توجد رؤوس قوائم — قم بتشغيل تعيين القوائم أولاً.",
      pickFolderRequired: "اختر مجلداً في \"الحفظ في مجلد\" قبل تشغيل العينة.",
      folderRef: "المجلد",
    },
    // Batch C · Round C2 · W6 — Inventory count worksheet (folder 1201) — AR
    inv6: {
      parsed: "تم التحليل", viewRows: "عرض الصفوف", noFile: "لم يُرفع ملف بعد — ارفع كشف الجرد",
      title: "ورقة عمل جرد المخزون",
      section: {
        count_details: "تفاصيل الجرد",
        mgmt_instructions: "تقييم تعليمات الإدارة للجرد",
        observation: "ملاحظات الحضور",
        condition: "الحالة (تالف / مُتقادم / بطيء الحركة)",
        test_counts: "عدّات الاختبار",
        final_records: "السجلات النهائية للمخزون",
        third_party: "المخزون لدى أطراف أخرى",
        attendance: "الحضور",
      },
      countDate: "تاريخ الجرد",
      locations: "المواقع",
      countedBy: "قام بالعدّ",
      countAtFsDate: "الجرد في تاريخ القوائم المالية؟",
      movements: "الحركات بين تاريخ الجرد وتاريخ القوائم المالية",
      damaged: "تالف", obsolete: "مُتقادم", slowMoving: "بطيء الحركة",
      sheetToFloor: "من الكشف إلى الأرض (من العينات)",
      floorToSheet: "من الأرض إلى الكشف (يُدخل هنا)",
      testColItem: "الصنف",
      testColLocation: "الموقع",
      listingQty: "الكمية بالكشف", countedQty: "الكمية المعدودة", diff: "الفرق",
      unitCost: "التكلفة للوحدة", valueDiff: "فرق القيمة",
      finalListing: "الكشف النهائي", countResults: "نتائج العدّ", tbTotal: "إجمالي الميزان",
      diffExplain: "تفسير الفرق",
      thirdPartyHeld: "لدى طرف آخر؟",
      thirdPartyName: "اسم الطرف الآخر",
      confirmationLink: "رابط المصادقة",
      otherProcedures: "ملاحظة إجراءات أخرى",
      attendanceMode: {
        attended: "تم الحضور",
        unable_unforeseen: "تعذّر الحضور — لظروف غير متوقعة",
        impracticable: "غير عملي",
      },
      attendanceReason: "السبب",
      altProcedures: "ملاحظة الإجراءات البديلة",
      uploadListing: "رفع كشف العدّ من العميل \u2068(.xlsx / .csv)\u2069",
      uploadListingFirst: "ارفع كشف العدّ من العميل أولاً.",
      uploadOk: "تم رفع الكشف.",
      totalValue: "إجمالي القيمة",
      sendToSampling: "إرسال إلى العينات — الجرد الفعلي",
      sendToSamplingOk: "تم الإرسال إلى العينات.",
      samplingSourceName: "الجرد الفعلي — كشف العدّ من العميل (1201)",
      addFloorRow: "إضافة صف من الأرض إلى الكشف",
      linkTo314a: "فتح 314(a) — ملاحظة جرد المخزون",
      mgmt: {
        coverage: "التغطية الكاملة",
        cut_off: "فصل الفترات",
        identification: "التمييز",
        recording: "التسجيل",
        custody: "العهدة",
        damaged_notes: "الإشارة إلى التالف / المُتقادم",
        note: "الملاحظات",
        evaluatedFlag: "تم تقييم التعليمات (بشكل عام)",
      },
      conclusion: "الاستنتاج", preparer: "المُعِد", reviewer: "المُراجِع",
      markComplete: "تعليم مكتمل",
      reasons: {
        attendance_not_set: "اضبط وضع الحضور.",
        alternative_procedures_required: "ملاحظة الإجراءات البديلة مطلوبة عند عدم تحقق الحضور.",
        management_instructions_not_evaluated: "قيِّم تعليمات الإدارة للجرد.",
        unexplained_final_difference: "فسِّر فرق السجلات النهائية.",
        conclusion_missing: "الاستنتاج مطلوب.",
        preparer_missing: "توقيع المُعِد مطلوب.",
        reviewer_missing: "توقيع المُراجِع مطلوب.",
      },
    },
  },
};

export default I18N_BASE_ANALYTICS;
